{
  "generic|:error": "An error occurred",
  "generic|:error-occurred": "An error occurred: {{message}}",
  "generic|:error-occurred__plural": "An error occurred: {{message}} and {{count}} other errors",
  "generic|:error-occured-contact-support": "An error occurred. Please, try again later. If the issue persists contact support.",
  "generic|:forbidden": "You do not have access to this operation",
  "generic|:not-found": "The requested resource doesn't exist",
  "generic|:user-not-found": "There is no user with this email",
  "generic|:user-already-participating": "This user is already participating",
  "generic|:relation-not-found": "One or more related resources don't exist",
  "generic|:unauthorized": "You are not authorized to perform this action",
  "generic|:unauthorized-space": "You are not authorized to perform this action in this space",
  "assignment-group|:name-already-exists": "Another assignment group with that name already exists.",
  "learning|:requires-event": "At least 1 location is required to create an event",
  "learning|:location|:capacity-reached": "There are no seats left for this event",
  "learning|:location|:already-enrolled": "You are already enrolled to this event",
  "learning|:location|:new-event-capacity-less-than-enrollments": "New capacity is too low to fit all participants",
  "uploads|:invalid-elearning-zip": "Zip file containes an unsupported or invalid e-learning",
  "learnifier|:participant-limit-reached": "Participant limit reached"
}
